// import './themes/generated/theme.base.css';
// import './themes/generated/theme.additional.css';
// import 'devextreme/dist/css/dx.common.css';
// import 'devextreme/dist/css/dx.carmine.compact.css';

import "devextreme/dist/css/dx.common.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.css";
import "./themes/sgt-cores.css";

import React, { Component, Suspense } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import appInfo from "./app-info";
import { navigation } from "./app-navigation";
import routes from "./app-routes";
import "./App.scss";
import "./dx-styles.scss";
import { Footer, LoginForm, RecoverPassword } from "./components";
import { SideNavOuterToolbar as SideNavBarLayout } from "./layouts";
import { sizes, subscribe, unsubscribe } from "./utils/media-query";
import UserInfo, { setForcarUpdate } from "./UserInfo";
import { SetShowError } from "./AppServices";
import { montarAvisoErro } from "./erros/avisoErro";
import JanelaErro from "./erros/JanelaErro";
import ptMessages from "devextreme/dist/js/localization/dx.messages.pt";
import { locale, loadMessages } from "devextreme/localization";
import { isAuthenticated, logout } from "./auth";
import { LoadIndicator } from "devextreme-react/load-indicator";
import AcessoNegado from "./pages/acessoNegado/AcessoNegado";

const LoginContainer = ({ logIn }) => <LoginForm onLoginClick={logIn} />;

const NotAuthPage = (props) => (
  <Switch>
    <Route exact path="/">
      <LoginContainer {...props} />
    </Route>
    <Route exact path="/recuperar-senha">
      <RecoverPassword />
    </Route>
    <Redirect to={"/"} />
  </Switch>
);

function criarRota(rotaItem) {
  
  if (rotaItem.recursoId != undefined) {
    if (!UserInfo.possuiRecurso(rotaItem.recursoId)) {
      if (!UserInfo.possuiPerfil(["trimap"])) {
        console.log("não possui recurso " + rotaItem.recursoId);

        return (
          <Route exact key={rotaItem.path} path={rotaItem.path}>
            <AcessoNegado recursoId={rotaItem.recursoId} />
          </Route>
        );
      }
    }
  }

  return (
    <Route
      exact
      key={rotaItem.path}
      path={rotaItem.path}
      component={rotaItem.component}
    />
  );
}

function obterTodasRotas(rotas) {
  let resultado = [];
  for (let i = 0; i < rotas.length; i++) {
    let rotaItem = rotas[i];
    if (rotaItem.perfis) {
      if (!UserInfo.possuiPerfil(rotaItem.perfis)) {
        continue;
      }
    }
    resultado.push({
      path: rotaItem.path,
      component: rotaItem.component,
      recursoId: rotaItem.recursoId,
    });
    if (rotaItem.tipo === "grade-form") {
      resultado.push({
        path: rotaItem.path + "/editar/:id",
        component: rotaItem.componentForm,
      });
      resultado.push({
        path: rotaItem.path + "/novo",
        component: rotaItem.componentForm,
      });
    }
    if (rotaItem.tipo === "rotas-imovel") {
      resultado.push({
        path: rotaItem.path + "/novo",
        component: rotaItem.componentForm,
      });
      resultado.push({
        path: rotaItem.path + "/editar/:id",
        component: rotaItem.componentForm,
      });
      resultado.push({
        path: rotaItem.path + "/editar/terreno/:id",
        component: rotaItem.componentFormTerreno,
      });
      resultado.push({
        path: rotaItem.path + "/editar/edificacao/:id",
        component: rotaItem.componentFormEdificacao,
      });
      resultado.push({
        path: rotaItem.path + "/editar/calculo-iptu/:id",
        component: rotaItem.componentFormCalculoIptu,
      });
    }
  }
  return resultado;
}

const AuthPage = (props) => (
  <SideNavBarLayout menuItems={navigation} title={appInfo.title} {...props}>
    <Suspense
      fallback={
        <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
          <LoadIndicator visible={true} width={48} height={48} />
        </div>
      }
    >
      <Switch>
        {obterTodasRotas(routes).map(criarRota)}
        <Redirect to={isAuthenticated() ? "/home" : "/"} />
      </Switch>
    </Suspense>
    <Footer>
      Central de Suporte Trimap - (85) 4042-3189 - WhatsApp
      <br />
      Copyright © 2013 - {new Date().getFullYear()} TRIMAP ASSESSORIA TRIBUTÁRIA LTDA. Todos os direitos reservados.
    </Footer>
  </SideNavBarLayout>
);

class App extends Component {
  constructor(props) {
    super(props);
    loadMessages(ptMessages);
    locale("pt");

    this.state = {
      loggedIn: true,
      aviso: null,
      avisoCentral: false,
      screenSizeClass: this.getScreenSizeClass(),
    };

    this.userMenuItems = [
      {
        text: "Perfil",
        icon: "user",
        onClick: this.profile,
      },
      {
        text: "Configurações",
        icon: "preferences",
        onClick: () => {
          this.router.history.push("/menu-configuracoes");
        },
      },
      {
        text: "Sair",
        icon: "runner",
        onClick: () => {
          logout();
          window.location.replace("/");
        },
      },
    ];

    setForcarUpdate(
      function () {
        this.forceUpdate();
      }.bind(this)
    );

    this.showError = this.showError.bind(this);
    this.fecharErro = this.fecharErro.bind(this);
    SetShowError(this.showError);
  }

  showError(data) {
    if (this.state.aviso && this.state.avisoCentral) return;

    this.setState({
      aviso: montarAvisoErro(data),
      avisoCentral:
        !!data && typeof data === "object" && data.central === true,
    });
  }

  fecharErro() {
    this.setState({ aviso: null, avisoCentral: false });
  }

  componentDidMount() {
    subscribe(this.screenSizeChanged);
  }

  componentWillUnmount() {
    unsubscribe(this.screenSizeChanged);
  }

  render() {
    const { loggedIn } = this.state;
    return (
      <div className={`app ${this.state.screenSizeClass}`}>
        <Router ref={this.getRouteRef}>
          {isAuthenticated() ? (
            <AuthPage userMenuItems={this.userMenuItems} />
          ) : (
            <NotAuthPage logIn={this.logIn} />
          )}
        </Router>
        <JanelaErro aviso={this.state.aviso} aoFechar={this.fecharErro} />
      </div>
    );
  }

  getScreenSizeClass() {
    const screenSizes = sizes();
    return Object.keys(screenSizes)
      .filter((cl) => screenSizes[cl])
      .join(" ");
  }

  screenSizeChanged = () => {
    this.setState({
      screenSizeClass: this.getScreenSizeClass(),
    });
  };

  logIn = () => {
    this.setState({ loggedIn: true });
  };

  logOut = () => {
    this.setState({ loggedIn: false });
  };

  getRouteRef = (r) => {
    this.router = r;
  };

  profile = () => {
    this.router.history.push("/profile");
  };
}

export default App;
